import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-updatefsc',
  imports: [],
  templateUrl: './updatefsc.component.html',
  styleUrl: './updatefsc.component.css'
})
export class UpdatefscComponent {
  constructor(private router: Router) {
    this.downloadNotes();
  }

  downloadNotes() {
    this.router.navigate(['/DOA']);
    const link = document.createElement('a');
    link.href = 'assets/NMA_BU_FSC_Update.doc';
    link.download = 'NMA_BU_FSC_Update.doc';
    link.click();
}
}
